import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { AccountCreditAdjustRequest } from "../shared/AccountCreditAdjustRequest";
import { AccountDebitAdjustRequest } from "../shared/AccountDebitAdjustRequest";
import { DataService_StudentFinesDebts } from "../shared/data.service";
import * as moment from "moment";

@Component({
	selector: "app-student-adjust-fine",
	templateUrl: "./student-adjust-fine.component.html",
	styleUrls: ["./student-adjust-fine.component.css"],
})
export class StudentAdjustFineComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private StudentFinesDebtsService: DataService_StudentFinesDebts
	) {}

	ngOnInit(): void {
		this.user = this.dialogConfig.data.user;
		this.SelectedPerson = this.dialogConfig.data.SelectedPerson;
		this.SelectedFine = this.dialogConfig.data.SelectedFine;

		this.UpdateData();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	//From parent
	user: any;
	SelectedPerson: any;
	SelectedFine: any;

	//Display Data
	StudentID: any = "";
	StudentName: any = "";
	TransactionDesc: any = "";
	FineDT: any = "";
	AdminName: any = "";
	OriginalComments: any = "";
	OriginalAmount: any = "";
	ItemBalance: any = "";

	NewBalance: any = 0;
	NewBalanceDesc: any = "";

	ItemBalanceNum: any = 0.0;

	//Form
	AdjustComments: any = "";
	AdjustAmount: any = 0.0;

	errorMessage: any = "";

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	UpdateData() {
		// console.log(this.SelectedFine);

		this.StudentID = this.SelectedPerson.DesignatorID;
		this.StudentName = this.SelectedPerson.PersonName;

		this.FineDT = this.SelectedFine.FineDateDesc;
		this.TransactionDesc = this.SelectedFine.FineTypeDesc;
		this.AdminName = this.SelectedFine.AdminName;
		this.OriginalAmount = this.SelectedFine.AmountDesc;
		this.ItemBalance = this.SelectedFine.BalanceDesc;
		this.ItemBalanceNum = this.SelectedFine.Balance;
		this.OriginalComments = this.SelectedFine.FineComment;

		this.NewBalance = this.SelectedFine.Balance;
		this.NewBalanceDesc = this.SelectedFine.BalanceDesc;
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////
	onAdjust() {
		this.errorMessage = "";

		//Error handling
		if (this.AdjustAmount <= 0) {
			this.errorMessage = "Adjust amount must be > 0";
			return;
		}
		if (this.AdjustAmount > this.ItemBalanceNum) {
			this.errorMessage = "Adjust amount must be < " + this.ItemBalanceNum;
			return;
		}

		//Pick method to call
		if (this.SelectedFine.TransactionType == "C") {
			this.AdjustCredit();
		} else {
			this.AdjustDebit();
		}
	}

	AdjustCredit() {
		let parms: AccountCreditAdjustRequest = {
			AccountCreditID: this.SelectedFine.FineID,
			PersonID: this.SelectedPerson.PersonID,
			Administrator_PersonID: this.user.personID,
			AccountCreditDT: moment(new Date()).format("MM/DD/YYYY HH:mm:00"),
			AccountCreditAmount: this.AdjustAmount,
			AccountCreditComment: this.AdjustComments,
			SchoolID: this.SelectedPerson.SchoolID,
		};

		//Call SP
		var result = this.StudentFinesDebtsService.AccountCreditAdjust(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "adjust",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Payment was adjusted successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "adjust",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not adjust the Payment",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	AdjustDebit() {
		this.AdjustAmount = Number(this.AdjustAmount).toFixed(2);

		let parms: AccountDebitAdjustRequest = {
			AccountDebitID: this.SelectedFine.FineID,
			PersonID: this.SelectedPerson.PersonID,
			Administrator_PersonID: this.user.personID,
			AccountDebitDT: moment(new Date()).format("MM/DD/YYYY HH:mm:00"),
			AccountDebitAmount: this.AdjustAmount,
			AccountDebitComment: this.AdjustComments,
			SchoolID: this.SelectedPerson.SchoolID,
		};

		//Call SP
		var result = this.StudentFinesDebtsService.AccountDebitAdjust(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "adjust",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Fine was adjusted successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "adjust",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not adjust the Fine",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////

	onAdjustAmountChange(val) {
		this.AdjustAmount = val;

		this.NewBalance = this.SelectedFine.Balance - this.AdjustAmount;
		this.NewBalanceDesc = "$" + Number(this.NewBalance).toFixed(2);
	}

	////////////////////////////////////////////
}
